import Vue from '@triotech/vue-core/src/vendor/vue';
import Root from '@triotech/vue-core/src/mixins/Root';
import Autoload from '@triotech/vue-core/src/helpers/autoload';
import VueYouTubeEmbed from 'vue-youtube-embed';
import '@triotech/vue-core/src/vendor/bootstrap-vue';
import '@triotech/vue-core/src/vendor/vue-notification';
import '@triotech/vue-core/src/vendor/trio-icons';
import '@triotech/vue-core/src/vendor/vue-slick';
import '@triotech/vue-core/src/vendor/vue-awesome';
import '@triotech/vue-core/src/vendor/moment';
import '@triotech/vue-core/src/vendor/vue-form-loading';
import '@triotech/vue-core/src/helpers/watchdog';
import 'moment-duration-format/lib/moment-duration-format';

Vue.use(VueYouTubeEmbed);

Autoload(require.context('@/plugins', false, /\.js$/));

export default new Vue({
  mixins: [
    Root,
  ],
  created() {
    this.$watchdog.mattermost();
  },
});
